import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { FormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { Bucket } from '../../types';
import { UiDialogShellComponent } from '../../ui/dialog-shell/dialog-shell.component';
import { UiButtonDirective } from '../../ui/button/button.directive';
import { UiInputDirective } from '../../ui/input/input.directive';

export interface ArchiveBudgetDialogData {
  bucket: Bucket;
  candidates: Bucket[];
  balance: number;
}

export interface ArchiveBudgetDialogResult {
  transferBalanceBucketId?: string;
}

@Component({
  selector: 'app-archive-budget-dialog',
  templateUrl: './archive-budget-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, CurrencyPipe, UiDialogShellComponent, UiButtonDirective, UiInputDirective],
})
export class ArchiveBudgetDialogComponent {
  dialogRef = inject<DialogRef<ArchiveBudgetDialogResult | undefined, ArchiveBudgetDialogComponent>>(DialogRef);
  data = inject<ArchiveBudgetDialogData>(DIALOG_DATA);

  transferBalanceBucketId = this.data.candidates[0]?.id ?? '';

  get balance(): number {
    return Math.round(this.data.balance * 100) / 100;
  }

  get needsTransferTarget(): boolean {
    return this.balance !== 0;
  }

  get transferLabel(): string {
    return this.balance > 0 ? 'Move remaining balance to' : 'Cover remaining balance from';
  }

  confirm(): void {
    this.dialogRef.close({
      ...(this.needsTransferTarget && this.transferBalanceBucketId
        ? { transferBalanceBucketId: this.transferBalanceBucketId }
        : {}),
    });
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
